module.exports = __webpack_public_path__ + "static/img/background.fb3004e6.svg";